import { render, staticRenderFns } from "./AddCountryPopup.vue?vue&type=template&id=36ec13b4&"
import script from "./AddCountryPopup.vue?vue&type=script&lang=js&"
export * from "./AddCountryPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports